<script module>
  export { default as layout } from '@layouts/authentication-layout.svelte'
</script>

<svelte:head>
  <title>Reset Password</title>
</svelte:head>

<script>
  import Form from '@components/forms'
  import { Link, useForm } from '@inertiajs/svelte'
  import Logo from '@assets/images/altruist-vertical-logo.svg'
  
  const form = useForm({
    email_address: ''
  })

  function handleSubmit(e) {
    e.preventDefault()
    $form.post('/passwords')
  }
</script>

<div class="flex min-h-0 flex-1 flex-col">
  <div class="flex flex-1 flex-col justify-center">
    <!-- Logo -->
    <div class="flex justify-center mb-10">
      <img src={Logo} alt="Altruist" class="w-32" />
    </div>

    <!-- Heading -->
    <h1 class="text-3xl font-serif text-center text-gray-700 mb-10">Reset your password</h1>

    <Form.Element {form} id="password-reset-form" class="auth-form" onsubmit={handleSubmit} allowEnterSubmit>

      <Form.Items class="gap-6">
        <Form.Item name="email_address" label="Email address" type="email" placeholder="your-email@company.com" bind:value={$form.email_address} validate={false} required />
      </Form.Items>

      <Form.Submit class="submit mt-8 flex-1 w-full justify-center" text="Email reset instructions" loading={$form.processing} />

    </Form.Element>
  </div>

  <div class="pt-4 text-center text-sm text-gray-700">
    <Link href="/session/new" class="text-gray-700 hover:text-primary-700 no-underline border-b-2 border-primary-500">Back to sign in</Link>
  </div>
</div>
